<template>
  <div class="ap-login-layout">
    <ap-language-switch/>
    <div>
      <ap-header />
      <div>
        <vis-loading size="md" v-if="loading" />
        <vis-error size="md" v-else-if="error" with-default :state="state" />
        <div v-else class="ap-login-layout__main">
          <div class="ba-w-full md:ba-w-auto ba-mt-10">
            <nav>
              <ul class="ba-flex ba-justify-center ba-select-none ba-space-x-6">
                <li
                  v-for="tab in filteredTabs"
                  :key="tab.routeName"
                  class="ba-text-3xl ba-font-bold"
                  :class="{
                    'ba-text-faint ba-opacity-50': $route.name !== tab.routeName,
                    'ba-pointer-events-none ba-font-medium':
                      $route.name === tab.routeName
                  }"
                >
                  <router-link :to="{ name: tab.routeName, query: { state } }">
                    {{ $t(tab.name) }}
                  </router-link>
                </li>
              </ul>
            </nav>
            <main>
              <slot />
            </main>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginMixin } from "@ba/visary-account-common-vue";
import { createSettings } from "@/utils/settings";
import ApHeader from "@/components/artek/ap-header";
import ApLanguageSwitch from "@/components/artek/ap-language-switch";

export default {
  name: "ap-login-layout",
  components: {
    ApHeader,
    ApLanguageSwitch
  },
  mixins: [loginMixin],
  data() {
    return {
      tabs: [
        {
          name: "tabs.loginTab",
          routeName: "login"
        },
        {
          name: "tabs.registerTab",
          routeName: "register"
        }
      ],
      settings: createSettings()
    };
  },
  computed: {
    filteredTabs() {
      return this.settings.canRegister ? this.tabs : [this.tabs[0]];
    }
  },
  watch: {
    loginInfo() {
      this.settings = createSettings(this.loginInfo?.clientId);
    }
  }
};
</script>
